import axios from "axios";
import { Global } from '../utils/general';
import headerRequest from "../utils/headers"

const API_URL = Global.url;

class AuthService {
    signIn(body) {
        const ruta = `${API_URL}/login`;
        return axios.post(ruta, body)
            .catch((error) => {
                return error.response;
            });
    }

    async signOut() {
        const headers = await headerRequest();
        const ruta = `${API_URL}/logout`;
        return axios.post(ruta, {
            headers: headers,
        }).catch((error) => {
            return error;
        });
    }

    async me() {
        const ruta = `${API_URL}/me`;
        const headers = await headerRequest();
        return axios.get(ruta, {
            headers: headers,
        }).catch((error) => {
            return error;
        });
    }

    async updatePassword(body) {
        const headers = await headerRequest();
        const ruta = `${API_URL}/updatePassword`;
        return axios.put(ruta, body, {
            headers: headers,
        }).catch((error) => {
            return error;
        });
    }
}

export default new AuthService();